<template>
  <div>
    <b-container fluid>
        <b-row>
            <div class="front-page">
                <b-card>
                    <div class="text">
                        <div class="logo">
                            <img src="/img/logo.png" class="menu-logo" id="menu-logo" alt="menu logo" />
                        </div>
                        <div class="division">
                            RISALA
                        </div>
                    </div>
                    <div v-if="(useSso == true ? false : true)" class="form-login pl-5 pr-5">
                        <b-form-input id="input-username" placeholder="Username" v-model="username" size="sm"></b-form-input>
                        <b-input type="password" id="input-password" placeholder="Password" class="mt-3" v-model="password" size="sm"></b-input>
                    </div>
                    <div class="action-button mt-4 mb-2 pl-5 pr-5">
                        <b-row>
                            <b-col>
                                <b-overlay
                                    :show="isLoggingIn"
                                    rounded
                                    opacity="0.6"
                                    spinner-small
                                    spinner-variant="primary"
                                    >
                                    <b-button class="btn-block" variant="success" @click="login">Login</b-button>
                                </b-overlay>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-if="loginFailed" class="pl-5 pr-5">
                        <span>Invalid username or password.</span>
                    </div>
                </b-card>
            </div>
        </b-row>
    </b-container>
  </div>
</template>
<style lang="scss" scoped>
   ::v-deep  .front-page {
        //background: #fff; /*url('/img/bg-yard-grayscaled.jpg') no-repeat center center / cover*/
        background-color: #ffffff;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3Crect stroke='%23ffffff' stroke-width='.5' width='1' height='1' id='s'/%3E%3Cpattern id='a' width='3' height='3' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cuse fill='%23fcfcfc' href='%23s' y='2'/%3E%3Cuse fill='%23fcfcfc' href='%23s' x='1' y='2'/%3E%3Cuse fill='%23fafafa' href='%23s' x='2' y='2'/%3E%3Cuse fill='%23fafafa' href='%23s'/%3E%3Cuse fill='%23f7f7f7' href='%23s' x='2'/%3E%3Cuse fill='%23f7f7f7' href='%23s' x='1' y='1'/%3E%3C/pattern%3E%3Cpattern id='b' width='7' height='11' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23f5f5f5'%3E%3Cuse href='%23s'/%3E%3Cuse href='%23s' y='5' /%3E%3Cuse href='%23s' x='1' y='10'/%3E%3Cuse href='%23s' x='2' y='1'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='8'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='5' y='2'/%3E%3Cuse href='%23s' x='5' y='6'/%3E%3Cuse href='%23s' x='6' y='9'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='h' width='5' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23f5f5f5'%3E%3Cuse href='%23s' y='5'/%3E%3Cuse href='%23s' y='8'/%3E%3Cuse href='%23s' x='1' y='1'/%3E%3Cuse href='%23s' x='1' y='9'/%3E%3Cuse href='%23s' x='1' y='12'/%3E%3Cuse href='%23s' x='2'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='2'/%3E%3Cuse href='%23s' x='3' y='6'/%3E%3Cuse href='%23s' x='3' y='11'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='4' y='10'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='c' width='17' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23f2f2f2'%3E%3Cuse href='%23s' y='11'/%3E%3Cuse href='%23s' x='2' y='9'/%3E%3Cuse href='%23s' x='5' y='12'/%3E%3Cuse href='%23s' x='9' y='4'/%3E%3Cuse href='%23s' x='12' y='1'/%3E%3Cuse href='%23s' x='16' y='6'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='d' width='19' height='17' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23ffffff'%3E%3Cuse href='%23s' y='9'/%3E%3Cuse href='%23s' x='16' y='5'/%3E%3Cuse href='%23s' x='14' y='2'/%3E%3Cuse href='%23s' x='11' y='11'/%3E%3Cuse href='%23s' x='6' y='14'/%3E%3C/g%3E%3Cg fill='%23efefef'%3E%3Cuse href='%23s' x='3' y='13'/%3E%3Cuse href='%23s' x='9' y='7'/%3E%3Cuse href='%23s' x='13' y='10'/%3E%3Cuse href='%23s' x='15' y='4'/%3E%3Cuse href='%23s' x='18' y='1'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='e' width='47' height='53' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%2384BC00'%3E%3Cuse href='%23s' x='2' y='5'/%3E%3Cuse href='%23s' x='16' y='38'/%3E%3Cuse href='%23s' x='46' y='42'/%3E%3Cuse href='%23s' x='29' y='20'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='f' width='59' height='71' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%2384BC00'%3E%3Cuse href='%23s' x='33' y='13'/%3E%3Cuse href='%23s' x='27' y='54'/%3E%3Cuse href='%23s' x='55' y='55'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='g' width='139' height='97' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%2384BC00'%3E%3Cuse href='%23s' x='11' y='8'/%3E%3Cuse href='%23s' x='51' y='13'/%3E%3Cuse href='%23s' x='17' y='73'/%3E%3Cuse href='%23s' x='99' y='57'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23b)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23h)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23c)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23d)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23e)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23f)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23g)' width='100%25' height='100%25'/%3E%3C/svg%3E");
        background-attachment: fixed;
        background-size: cover;
        height: 100%;
        left: 0;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 1000;

        .card {
            background-color: #fff;
            box-shadow: 0 1px 20px rgb(207, 207, 207);
            left: 50%;
            min-width: 260px;
            max-width: 500px;
            position: absolute;
            text-align: center;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 80%;
        }

        .card-body {
            padding-right: 0px;
            padding-left: 0px;
        }

        .text {
            padding: 30px 30px 20px 30px;

            .division {
                color: #555;
                font-size: 24px;
                font-weight: bold;
                margin-top: 20px;
                position: relative;

                &:before {
                    position: absolute;
                    top: -5px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 50px;
                    height: 1px;
                    background-color: rgba(100, 100, 100, 0.5);
                    content: "";
                }
            }

            img {
                display: block;
                margin: 0 auto;
                height: 100px;
            }

            .error-login {
                border-width:medium;
                font-size:medium;
                color: #CC0400;
                text-align: center;
                border:solid;
                border-color: red;
            }

            .error {
                color: #CC0400;
                text-align: left;
            }
        }

        .form-login {
            background: #84BC00;
            padding: 20px;
        }
        .action-button {
            .btn-success {
                color: #fff;
                font-weight: 600;
                background-color: #84BC00;
                border-color: #84BC00;
            }
            .btn-success:active, .btn-success:focus, .btn-success:hover {
                background-color: #6b9801 !important;
                border-color: #6b9801 !important;
            }
        }
    }
</style>
<script>
import { domain, clientId } from "../../../auth_config.json";
import { mapGetters } from 'vuex'

export default {
    components : {},
    name: 'Login',
    data() {
      return {
        username : "",
        password : "",
        token : "",
        loginFailed: false,
        model: {},
        useSso: false,
        isLoggingIn: false,
      }
    },
    computed: {
        ...mapGetters({
            accessToken: 'accessToken',
            isLoggedIn: 'isLoggedIn',
            user: 'user'
        })
    },
    methods: {
        login() {
            this.dologin();
        },
        dologin() {
            let model = {
                "username": this.username,
                "password" : this.password,
                "grant_type" : "password"
            };
            this.loginFailed = false;
            this.isLoggingIn = true;
            this.$store.dispatch('login', model)
            .then(response => {
                this.$router.replace({ name: 'home' });
                this.loginFailed = false;
                this.isLoggingIn = false;
            }).catch(error => {
                this.loginFailed = true;
                this.isLoggingIn = false;
            });
        },
    },
    mounted() {
        var _this = this;
    },
    beforeDestroy() { 
    },
}
</script>